import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class NotificationApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getNotifications(filter: NotificationsFilterDAO = {}): Observable<PaginatedResponseDAO<NotificationDAO>> {
    const params = new HttpParams({
      fromObject: {
        ...(filter.limit && { limit: filter.limit.toString() }),
        ...(filter.offset && { offset: filter.offset.toString() }),
        ...(filter.isRead !== undefined && { isRead: filter.isRead.toString() }),
        ...(filter.actionType && { actionType: filter.actionType }),
        ...(filter.objectType && { objectType: filter.objectType }),
        ...(filter.type && { type: filter.type })
      }
    });

    return this.httpClient.get<PaginatedResponseDAO<NotificationDAO>>(`${this.baseUrl}/notifications`, { params });
  }

  public getTotalUnread(): Observable<{ total: number }> {
    return this.httpClient.get<{ total: number }>(`${this.baseUrl}/notifications/total-unread`);
  }

  public markAsRead(notificationId: string): Observable<void> {
    return this.httpClient.patch<void>(`${this.baseUrl}/notifications/${notificationId}/read`, {});
  }

  public markAllAsRead(input?: MarkAllReadInputDAO): Observable<void> {
    return this.httpClient.patch<void>(`${this.baseUrl}/notifications/mark-all-read`, input || {});
  }

  public getNotification(id: string): Observable<NotificationDAO> {
    return this.httpClient.get<NotificationDAO>(`${this.baseUrl}/notifications/${id}`);
  }
}
